<template>
  <div id="zfbInfoFillingPage">
    <div class="headline">填写参保信息</div>
    <div class="fillContentList">
      <div class="punctuation">
        <span ></span>
        <span >被保险人信息</span>
      </div>
      <ul class="beInsureWrap">
        <li class="relaWrap" hidden>
          <div class="tit fl">关系：</div>
          <div class="sInfo">
            <input type="text" placeholder="其他"  disabled="disabled" v-model="relationship" />
          </div>
        </li>
        <li>
          <div class="tit">姓名：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入被保险人姓名" v-model="insuredName"/>
          </div>
        </li>
        <li>
          <div class="tit">证件类型：</div>
          <div class="sInfo select">
            <div @click="cardPopupState = true">{{abbreviation ? abbreviation : '请选择'}}</div>
          </div>
          <van-popup v-model="cardPopupState" v-if="cardPopupState" position="bottom" class="cardPopupState">
            <van-picker
              show-toolbar
              :columns="columns"
              @cancel="cardPopupState = false"
              @confirm="confirmInsureCardType"
            />
          </van-popup>
        </li>
        <li>
          <div class="tit">证件号码：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入被保险人证件号码" v-model="insuredIdCard" maxlength="20" onKeyUp="value=value.replace(/[\W]/g,'')" />
          </div>
        </li>
        <li>
          <div class="tit">手机号：</div>
          <div class="sInfo">
            <input type="text" placeholder="请输入手机号" v-model="insuredMobile" maxlength="11" onkeyup="value=value.replace(/[^\d]/g,'')" disabled="disabled" />
          </div>
        </li>
        <li v-if="cardState">
          <div class="tit">出生日期：</div>
          <div class="sInfo">
            <div class="block">
              <el-date-picker
                v-model="brithday"
                type="date"
                align="center"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                class="my-el-date-picker-add">
              </el-date-picker>
            </div>
          </div>
        </li>
        <li v-if="cardState">
          <div class="tit">性别：</div>
          <div class="sInfo">
            <el-radio v-model="sex" label="M">男</el-radio>
            <el-radio v-model="sex" label="F">女</el-radio>
          </div>
        </li>
      </ul>
    </div>

    <!-- 声明 -->
    <div class="declaration">
      <van-checkbox v-model="checkDeclaration" checked-color="#017a59" shape="square" class="checkDeclaration"></van-checkbox>
      <b>本人声明并同意以下内容：</b>
      <span>
        我已知晓“肇福保”必须满足参保人享有2023年度肇庆基本医疗保险的情况下方可进行理赔，如参保人无肇庆基本医保则无法享受到该保障，
        保司有权取消参保人的“肇福保”的参保资格并按原路退还本人保费。
      </span>
    </div>

    <!-- 阅读协议 -->
    <div class="readAgreement">
      <van-checkbox v-model="checkReadAgreement" @change="chooseReadAgreement()" checked-color="#017a59" shape="square" class="checkReadAgreement"></van-checkbox>
      <b>本人已知悉：</b>
      <span>
        <span>本产品的被保险人仅限符合参保范围的人员，已经阅读并同意</span>
        <span class="clauseUnit" @click="chooseReadAgreement(1)">《参保须知》</span>
        <span class="clauseUnit" @click="chooseReadAgreement(2)">《参保细则》</span>
        <span class="clauseUnit" @click="chooseReadAgreement(3)">《保障计划及产品条款》</span>
        <span class="clauseUnit" @click="chooseReadAgreement(4)">《理赔须知》</span>
        <span class="clauseUnit" @click="chooseReadAgreement(5)">《授权申明、重要内容提示及信息安全承诺》</span>
        <span class="clauseUnit" @click="chooseReadAgreement(6)">《健康增值服务手册》</span>
        <span class="clauseUnit" @click="chooseReadAgreement(7)">《免责条款》</span>
        <span class="clauseUnit" @click="chooseReadAgreement(8)">《严重既往症赔付比例告知》</span>
      </span>
    </div>

    <footer>
      <div class="footerUnit">
        <a class="kefu" href="https://work.weixin.qq.com/kfid/kfce82ed2eaaae38c7f">
          <div class="kefu">
            <div class="kefuImg"></div>
            <div class="kefuText">客服</div>
          </div>
        </a>
        <div class="submit" @click="submitOrder">提交</div>
      </div>
    </footer>

    <!-- 阅读协议 - 弹窗 -->
    <van-popup
      v-model="readAgreementPopup"
      closeable
      position="bottom"
      class="readAgreementPopup"
      v-if="readAgreementPopup"
      @click-overlay="checkReadAgreement = false"
      @click-close-icon="checkReadAgreement = false"
    >
      <div class="content">
        <div class="tabList">
          <div class="tabUnit selectTab" @click="tabUnit(1)">《参保须知》</div>
          <div class="tabUnit" @click="tabUnit(2)">《参保细则》</div>
          <div class="tabUnit" @click="tabUnit(3)">《保障计划及产品条款》</div>
          <div class="tabUnit" @click="tabUnit(4)">《理赔须知》</div>
          <div class="tabUnit" @click="tabUnit(5)">《授权申明、重要内容提示及信息安全承诺》</div>
          <div class="tabUnit" @click="tabUnit(6)">《健康增值服务手册》</div>
          <div class="tabUnit" @click="tabUnit(7)">《免责条款》</div>
          <div class="tabUnit" @click="tabUnit(8)">《严重既往症赔付比例告知》</div>
          <div class="line">
            <div class="sliding">
              <div class="slidingBlock"></div>
            </div>
          </div>
        </div>
        <div class="imgList">
          <img class="agreementContent1" src="https://pic.xiaobaibao.com/clause/2022/11/5a6ad5a764444291aae6c7add21aa980.png" alt="参保须知" >
          <img class="agreementContent2" src="https://pic.xiaobaibao.com/clause/2022/11/84ab8343ecab4b59bf36cc841ce7725b.png" alt="参保细则" >
          <img class="agreementContent3" src="https://pic.xiaobaibao.com/clause/2022/11/353105728d34458baf1498606e79e671.png" alt="保障计划及产品条款" >
          <img class="agreementContent4" src="https://pic.xiaobaibao.com/clause/2022/11/cfbf0ddf549a4a039d35fcf086270522.png" alt="理赔须知" >
          <img class="agreementContent5" src="https://pic.xiaobaibao.com/clause/2022/11/2ef9d39930a94f909e569aca42adfa49.png" alt="授权申明、重要内容提示及信息安全承诺" >
          <img class="agreementContent6" src="https://pic.xiaobaibao.com/clause/2022/11/ffe62cca07754120b453126176016146.png" alt="健康增值服务手册" >
          <img class="agreementContent7" src="https://pic.xiaobaibao.com/clause/2022/11/51868f460df348cdb6d8275304b2c5f5.png" alt="免责条款" >
          <img class="agreementContent8" src="https://pic.xiaobaibao.com/clause/2022/11/744a191d9e0f4252816471425889c8b0.png" alt="严重既往症赔付比例告知" >
        </div>
        <div class="footer">
          <button @click="readAgreementPopup = false">
            <span>已阅读,并同意上述内容</span>
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: "zfbInfoFillingPage",
    data() {
      return {
        skuList: [],
        rightsToken: '',
        eventLogToken: '',
        saleToken: 'kr7CfMZLMHaR0xkqoAMTAQ==',
        skuId: '',
        phoneType: '',
        insureCardTypeList: [
          {label: '居民身份证(户口薄)', value: '1', abbreviation: '身份证'},
          {label: '中国人民解放军军官证', value: '2', abbreviation: '军官证'},
          {label: '中国人民武装警察警官证', value: '14', abbreviation: '警察证'},
          {label: '香港特区护照/港澳居民来往内地通行证', value: '15', abbreviation: '香港护照'},
          {label: '澳门特区护照/港澳居民来往内地通行证', value: '16', abbreviation: '澳门护照'},
          {label: '台湾居民来往大陆通行证', value: '5', abbreviation: '台湾通行证'},
          {label: '外国人永久居留证', value: '17', abbreviation: '外国人永久居留证'},
          {label: '外国人护照', value: '10', abbreviation: '外国人护照'},
          {label: '残疾人证', value: '18', abbreviation: '残疾人证'},
          {label: '军列属证明', value: '19', abbreviation: '军列属证明'},
          {label: '外国人就业证', value: '20', abbreviation: '外国人就业证'},
          {label: '外国专家证', value: '21', abbreviation: '外国专家证'},
          {label: '外国人常驻记着证', value: '22', abbreviation: '外国人常驻记着证'},
          {label: '台港澳人员就业证', value: '23', abbreviation: '台港澳人员就业证'},
          {label: '回大陆(内地)定居专家证', value: '24', abbreviation: '回大陆定居专家证'},
          {label: '港澳台居民居住证', value: '25', abbreviation: '港澳台居民居住证'},
          {label: '社会保障卡', value: '26', abbreviation: '社会保障卡'},
          {label: '其他身份证件', value: '27', abbreviation: '其他身份证件'},
        ],
        columns: [
          '居民身份证(户口薄)'
        ],
        cardPopupState: false,
        cardState: false,
        //-- 受益人信息
        cardType: '1',
        insureCardType: '居民身份证(户口薄)',
        abbreviation: '身份证',
        relationship: '其它',
        insuredName: '',
        insuredIdCard: '',
        insuredMobile: '',
        brithday: '',
        sex: 'M',
        /* 勾选 */
        checkDeclaration: false,
        checkReadAgreement: false,
        /* 阅读协议弹窗 */
        readAgreementPopup: false,
        pdfUrl: "https://pic.xiaobaibao.com/clause/2021/10/e18184f2896e4f1883b892726e445f47.pdf",
        numPages: null,
        lineWidthList: [],
        lineWidthListValue: 1,
      }
    },
    methods: {
      // 确认证件类型
      confirmInsureCardType(values){
        let that = this,
          {insureCardTypeList} = that;

        for (let i in insureCardTypeList){
          const {abbreviation, label, value} = insureCardTypeList[i];

          if (values == label){
            that.cardType = value;
            that.insureCardType = label;
            that.abbreviation = abbreviation;
          }
        }

        this.cardPopupState = false;
      },

      // 打开 - 预览条款
      chooseReadAgreement(value){
        let that = this;

        if (!that.checkReadAgreement && !that.$$.isValidObj(value)) return;

        that.readAgreementPopup = true;
        if (that.$$.isValidObj(value)) that.lineWidthListValue = value;

        setTimeout(function () {
          let tabUnitNum = $(`.tabList`).children('.tabUnit').length;
          for (let i = 0; i < tabUnitNum; i++) {
            let tabUnitWidth = $(`.tabList>div:nth-child(${i+1})`).width();
            that.lineWidthList[i] = tabUnitWidth;
          }

          that.tabUnit(that.lineWidthListValue);
        }, 500);
      },

      // 切换 - 协议弹窗标题
      tabUnit(value){
        let that = this;

        if (that.$$.isValidObj(value)) that.lineWidthListValue = value;
        $(`.tabList>div:nth-child(${value})`).addClass("selectTab").siblings().removeClass("selectTab");
        $(`.imgList .agreementContent${value}`).addClass('showCurrent').siblings().removeClass('showCurrent');
        $(".readAgreementPopup").scrollTop(0);

        let target = $(`.tabList>div:nth-child(${value})`),           // 当前元素
          halfScreenWidth = window.innerWidth/2,                      // 一半屏幕宽度
          ulWidth = $(".tabList").width(),                            // 主题宽度
          leftWidth = (target.width()/2) + target.get(0).offsetLeft,  // 点击元素中点距离屏幕左侧
          rightWidth = ulWidth - leftWidth,                           // 点击元素中点距离屏幕右侧
          width = target.width();

        if(leftWidth > halfScreenWidth){
          $(".tabList").animate({scrollLeft: leftWidth - halfScreenWidth}, 'speed'); // 滚动到中间
        }else if(rightWidth < halfScreenWidth){
          $(".tabList").animate({scrollLeft:(window.devicePixelRatio*window.innerWidth)-ulWidth}, 'speed'); // 滚动到末尾
        }else{
          $(".tabList").animate({scrollLeft: 0}, 'speed'); // 滚动到最前
        }

        // 移动滑条
        let totalDistance = 0;
        for (let i in that.lineWidthList){
          if (parseInt(i)+1 == value) break;
          totalDistance += that.lineWidthList[i];
        }

        value = totalDistance + width/2 - 20;

        $(".tabList .line").css({
          '-webkit-transform': `translate(${value}px, 0)`,
          'transform': `translate(${value}px, 0)`,
        });

      },

      //-- 获取权益数据
      getRightsInfo(){
        let that = this;
        let loading = that.Loading.service({fullscreen: true});
        that.axios.post('/management/unicom/getRightsInfo', {rightsToken: that.rightsToken}).then((response) => {
          that.$nextTick(() => loading.close());
          let data = response.data;

          if (data.success) {
            const {cpPhoneMoney, phoneNum, skuList} = data.datas;
            that.skuList = skuList;
            that.cpPhoneMoney = cpPhoneMoney;
            that.insuredMobile = phoneNum;
          }else {
            that.$$.alert({
              message: data.msg,
              type: data.msg == '权益已领取!' ? "success":"info",
              onOk: function () {
                that.$router.go(-1);
              }
            });

            if (data.msg == '权益已领取!'){
              localStorage.removeItem('interests_rightsToken'+that.saleToken);
              localStorage.removeItem('interests_loginAccount'+that.saleToken);
              localStorage.removeItem('interests_router'+that.saleToken);
              localStorage.removeItem('interests_eventLogToken'+that.saleToken);
            }
          }
        });
      },
      //-- 领取权益
      submitOrder(){
        let that = this,
          {rightsToken, insuredName, insuredIdCard, insuredMobile, cardType, brithday, sex} = that;

        //-- 校验
        const errorMsg = that.validationForm();
        if(that.$$.isValidObj(errorMsg)) return that.$message.error(errorMsg);

        brithday = brithday.replace(/-/g,'');

        // 其他信息
        let extendJson = {};

        // 受益人信息
        let insuredList = [{
          insuredName,
          insuredIdCard,
          insuredMobile,
          cardType,
        }];

        if (cardType != 1){
          insuredList[0]["brithday"] = brithday;
          insuredList[0]["sex"] = sex;
        }

        let params = {
          "rightsToken": rightsToken,
          "extendJson": JSON.stringify(extendJson),
          "insuredList": JSON.stringify(insuredList),
          "skuId": that.skuId,
          "eventLogToken": that.eventLogToken
        };

        // console.log(params);
        // return;

        let loading = that.Loading.service({fullscreen: true});
        that.axios.post('/management/unicom/submitOrder', params).then((response) => {
          that.$nextTick(() => loading.close());
          let data = response.data;

          if (data.success) {
            this.$$.alert({
              message: "参保申请已登记，核保结果短信通知，敬请留意。",
              type: "success",
              onOk: function () {
                // console.log(data);
                localStorage.removeItem('interests_rightsToken'+that.saleToken);
                localStorage.removeItem('interests_loginAccount'+that.saleToken);
                localStorage.removeItem('interests_router'+that.saleToken);
                localStorage.removeItem('interests_eventLogToken'+that.saleToken);

                that.$router.go(-1);
              }
            });
          }else {
            that.errorPrompt = data.msg;
          }
        });
      },
      //-- 校验
      validationForm(){
        let that = this;
        const {insuredName, insuredIdCard, insuredMobile, cardType, insureCardType, brithday} = that;

        // 获取SkuId
        for (let i in that.skuList){
          let unit = that.skuList[i];

          that.skuId = unit['skuId'];
        }

        if(!that.$$.isValidObj(insuredName)) return "请输入姓名~";
        if (that.$$.constant.nameReg.test(insuredName) === false) return "姓名不正确!";

        if (cardType == 1){
          if(!that.$$.isValidObj(insuredIdCard)) return "请输入身份证号~";
          if (that.$$.constant.beInsureIdTypeOneReg.test(insuredIdCard) === false) return "身份证格式不正确!";
        }else {
          if(!that.$$.isValidObj(insuredIdCard)) return `请输入${insureCardType}~`;
        }

        // if(!that.$$.isValidObj(insuredMobile)) return "请输入手机号~";
        // if (that.$$.constant.phoneReg.test(insuredMobile) === false) return "手机号格式不正确!";

        if(cardType != 1 && !that.$$.isValidObj(brithday)) return "请选择出生日期~";

        if (!that.checkDeclaration) return "请先阅读并同意医保身份声明~";
        if (!that.checkReadAgreement) return "请先阅读并同意投保需知书~";
      },

    },
    mounted() {
      let that = this;

      that.rightsToken = that.$route.query.rightsToken;

      //-- 获取权益数据
      if (that.$$.isValidObj(that.rightsToken)) {
        that.getRightsInfo();
      }else {
        that.$$.alert({
          message: '参数有误，请重新领取权益!',
          onOk: function () {
            that.$router.go(-1);
          }
        });
      }

      // 录制token
      let eventLogToken = decodeURIComponent(encodeURIComponent(that.$route.query.eventLogToken).replace(new RegExp("%20","gm"),"%2B"));
      if (that.$$.isValidObj(eventLogToken)) {
        that.screenRecBase.startLoad();
        that.eventLogToken = eventLogToken;
      }
    }
  }
</script>

<style scoped>
  #zfbInfoFillingPage{
    max-width: 750px;
    margin: 0 auto;
    position: relative;
    width: 100%;
    height: 100vh;
    background: #f5f6f7;
    padding: 0 0 60px;
  }
  /* 内容*/
  .headline{
    font-size: 1.6rem;
    font-weight: bold;
    padding: 1rem;
    border-bottom: 1px solid #F2F4F7;
    margin-bottom: 15px;
  }

  .fillContentList{
    padding: 0 1rem;
    background: #ffffff;
  }

  .punctuation{
    line-height: 18px;
    padding: 5px 0;
    border-bottom: 1px solid #F2F4F7;
    font-size: 1.4rem;
  }

  .punctuation>span{
    display: inline-block;
    vertical-align: middle;
  }

  .punctuation>span:first-child{
    width: 3px;
    height: 16px;
    color: #ffffff;
    background: #04aa7a;
    text-align: center;
    margin-right: 2px;
  }

  .beInsureWrap li{
    height: 50px;
    min-height: 50px;
    margin: 0 10px;
    font-size: 1.4rem;
    border-bottom: 1px solid #F2F4F7;
    position: relative;
  }

  .tit {
    width: 30%;
    height: 100%;
    letter-spacing: 1px;
    float: left;
    display: flex;
    align-items: center
  }

  .arrow:after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -5px;
    display: block;
    width: 10px;
    height: 10px;
    border-right: 2px solid #064f98;
    border-bottom: 2px solid #064f98;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  .sInfo {
    width: 69%;
    height: 100%;
    color: #CCCCCC;
    background: #ffffff;
    float: right;
    text-align: right;
    display: flex;
    align-items: center;
  }
  .sInfo div{
    width: 100%;
    font-size: 1.4rem;
    color: #FA6E50;
  }

  input::-webkit-input-placeholder{
    color: #CCCCCC;
    font-weight: 400;
    font-size: 1.4rem;
  }
  input{
    width: 100%;
    text-align: right;
    font-size: 1.4rem;
    color: #FA6E50;
  }

  .cardPopupState  {
    width: 100%;
    z-index: 2100!important;
  }

  /* 声明 */
  .declaration{
    color: #000000;
    font-size: 1.4rem;
    padding: 2rem 1.5rem 1rem;
  }
  .checkDeclaration{
    display: inline-block;
  }


  /* 阅读协议 */
  .readAgreement{
    color: #000000;
    font-size: 1.4rem;
    padding: 1rem 1.5rem;
  }
  .checkReadAgreement{
    display: inline-block;
  }
  .readAgreement .clauseUnit{
    margin: 0 auto;
    color: #2e77ee;
  }

  /* 底部 */
  footer{
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 101;
    background: #ffffff;
    width: 100%;
  }
  .footerUnit{
    max-width: 750px;
    margin: 0 auto;
    text-align: center;
    height: 5rem;
    display: flex;
  }
  .kefu{
    padding: 0 1.6rem;
    height: 100%;
    margin: 0 auto;
    text-align: center;
  }
  .kefuImg{
    width: 3rem;
    max-height: 3rem;
    padding-top: 100%;
    background: url("../../../../static/images/product/zfb/kefu.png") no-repeat center / cover;
  }
  .kefuText{
    text-align: center;
    font-size: 1.33rem;
    line-height: 2rem;
  }
  .submit{
    flex: 1;
    background: -webkit-linear-gradient(left,#00b07b,#017a59);
    background: linear-gradient(90deg,#00b07b,#017a59);
    color: #ffffff;
    font-size: 1.5rem;
    line-height: 5rem;
  }

  /* 阅读协议 - 弹窗 */
  .readAgreementPopup{
    padding: 5rem 0 4rem;
    height: 80%;
    z-index: 2100!important;
  }
  .readAgreementPopup /deep/ .van-popup__close-icon{
    width: 3.6rem;
    height: 2.5rem;
    line-height: 3rem;
    text-align: center;
    position: fixed;
    top: unset;
    right: 0;
    bottom: calc(80%);
    z-index: 2006;
    background: #ffffff;
    border-radius: 2rem 2rem 0 0;
  }

  .tabList{
    height: 5rem;
    line-height: 5rem;
    width: 100%;
    position: fixed;
    bottom: calc(80% - 5rem);
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 2101!important;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    padding: 0 2.133vw 0 2.133vw;
    color: #333333;
    background: #ffffff;
  }
  .tabList::-webkit-scrollbar{
    display: none;
  }

  .tabList .tabUnit{
    font-size: 1.4rem;
  }

  .tabList .selectTab{
    color: #074f98;
  }

  .tabList .line{
    display: block;
    padding-left: 2.133vw;
    position: absolute;
    top: 4.2rem;
    left: 0;
    z-index: 2100!important;
    -webkit-transition: -webkit-transform .5s;
    -o-transition: transform .5s;
    transition: transform .5s, -webkit-transform .5s;
    -webkit-transform: translate(0, 0);
    -ms-transform: translate(0, 0);
    transform: translate(0, 0);
  }

  .tabList .line .slidingBlock{
    border: 1px solid #064f98;
    width: 4rem;
    margin: 0 auto;
    text-align: center;
  }

  .readAgreementPopup .footer{
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 2101!important;
  }
  .readAgreementPopup .footer button{
    color: white;
    background: linear-gradient(90deg,#00b07b,#017a59);
    border: 0;
    width: 100%;
    height: 4rem;
    font-size: 1.5rem;
    position: relative;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    -webkit-transition: opacity .2s;
    transition: opacity .2s;
    -webkit-appearance: none;
  }

  .imgList{
    height: 100%;
    width: 100%;
    z-index: 2101!important;
  }
  .imgList>img{
    display: none;
  }
  .imgList>img.showCurrent{
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/zfb/infoFillingPage.vue